import { ref } from 'vue';

const getMyWebpages = () => {
    const myWebpages_error = ref(null);
    const myWebpages = ref(null);
   // console.log("webpages: ");
  
    
    const loadMyWebpages = async (filter, newsFilter) => {
        
       try {
            var params = [];
            if (filter) {
                    params.push(['filter', filter]);
            }

            if (newsFilter) {
                    params.push(['newsFilter',newsFilter]);
            }

            let data = await fetch("/api/webpages?" + new URLSearchParams(params));

            if (!data.ok) {
                throw Error("Can't load data");
            }

            myWebpages.value = await data.json();
           // console.log("webpages: " , myWebpages.value);
        } catch (err) {
            console.log("Error: " , err.message);
            myWebpages_error.value = err.message;
        }
    };

    return { myWebpages, myWebpages_error, loadMyWebpages };
}

export default getMyWebpages;
